import {RestResource} from '../rest'

import {WORK_ORDER_SERVER} from '../server'
import {athubAxios} from "../../util/athub-axios";

const jobPlan = new RestResource({server: WORK_ORDER_SERVER, resource: 'eamJobplan'});

jobPlan._getOperationsUrl = [jobPlan.server, jobPlan.resource, '{id}', 'operations'].join('/');
jobPlan.getOperations = function(id, athubConfig) {
  return athubAxios.get(jobPlan._getOperationsUrl.replace('{id}', id), athubConfig);
};

jobPlan._workflowAuditUrl = [jobPlan.server, jobPlan.resource, 'workflow', 'audit'].join('/');
jobPlan.workflowAudit = function(params, athubConfig) {
  return athubAxios.postByMultipartForm(jobPlan._workflowAuditUrl, params, athubConfig);
};
jobPlan._updateStatusUrl = [jobPlan.server, jobPlan.resource, '{id}', 'status', '{status}', '{oldStatus}'].join('/');
jobPlan.updateStatus = function(id, status, oldStatus, athubConfig) {
  return athubAxios.put(
      jobPlan._updateStatusUrl
          .replace('{id}', id)
          .replace('{status}', status)
          .replace('{oldStatus}', oldStatus)
      , athubConfig);
};

export default jobPlan;